import { render, staticRenderFns } from "./vendorBusinessCatgLKU.vue?vue&type=template&id=644895c8"
import script from "./vendorBusinessCatgLKU.vue?vue&type=script&lang=js"
export * from "./vendorBusinessCatgLKU.vue?vue&type=script&lang=js"
import style0 from "./vendorBusinessCatgLKU.vue?vue&type=style&index=0&id=644895c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports